module.exports = __webpack_public_path__ + "img/shutdown_1_1.fca0ac04.webp";